// extracted by mini-css-extract-plugin
export default {"base":"components-Shared-OnTvBadge-styles__base--W96t5"};